// ============================================
// B356 (AI_154) — OBTER NUMERAÇÃO A PARTIR DE hepato.app (ticket)
// ============================================
// O login gov.br do SNCR só volta para domínios .br. Em vez de exigir que o
// médico entre no app em hepato.app.br, o hepato.app (já logado) pede ao
// servidor um TICKET de uso único (10 min) e abre uma aba em hepato.app.br com
// ele; essa aba vai direto ao gov.br, obtém os blocos e os entrega ao servidor,
// que os grava no cofre do médico. Ver api/sncr-ticket.js.

import { getIdTokenSafe } from "../../lib/authFetch";
import { ambienteSncr, ENDERECO_PAGINA_SNCR, LIMITES_RCE_RET } from "./configSncr";
import { TipoNumeracao } from "./numeracaoSncr";

const NOME: Record<TipoNumeracao, string> = {
  RCE: "controle especial",
  RET: "antimicrobiano/GLP-1",
};

/**
 * Abre a aba do gov.br para obter numeração. Chamar DIRETO no clique (a aba é
 * aberta antes do pedido ao servidor, senão o bloqueador de pop-up a barra).
 */
export async function abrirObtencaoPeloApp(tipos: TipoNumeracao[]): Promise<void> {
  if (!tipos.length) return;
  const ok = window.confirm(
    `Obter numeração do SNCR: ${tipos.map((t) => NOME[t]).join(" e ")}.\n\n` +
      `Vai abrir uma aba do gov.br. Entre com o SEU gov.br; ao terminar, a aba avisa e pode ser fechada.\n\n` +
      `Cada pedido traz ${LIMITES_RCE_RET.numerosPorPedido} números e a Anvisa permite ${LIMITES_RCE_RET.pedidosPorMes} pedidos por mês.\n\nContinuar?`
  );
  if (!ok) return;
  const aba = window.open("", "_blank");
  if (!aba) {
    alert("O navegador bloqueou a nova aba. Permita pop-ups para hepato.app e tente de novo.");
    return;
  }
  aba.document.title = "SNCR";
  aba.document.body.innerHTML =
    '<p style="font-family:sans-serif;padding:24px">Preparando o acesso ao gov.br…</p>';
  try {
    const token = await getIdTokenSafe("sncr-ticket");
    if (!token) throw new Error("Sessão do app expirada. Entre de novo.");
    const resp = await fetch("/api/sncr-ticket", {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
      body: JSON.stringify({ acao: "criar", tipos, ambiente: ambienteSncr() }),
    });
    const r = await resp.json().catch(() => ({}));
    if (!resp.ok || !r?.ticket) throw new Error(r?.error || `HTTP ${resp.status}`);
    const url = `${ENDERECO_PAGINA_SNCR}?ticket=${encodeURIComponent(r.ticket)}`;
    aba.location.href = url;
  } catch (e: any) {
    aba.close();
    alert(`Não foi possível iniciar a obtenção da numeração: ${e?.message || "erro"}.`);
  }
}
